import { APP_ERROR_CODE } from './JsonRpcError';
import { truncate } from './logString';
import type { ApplicationError } from './JsonRpcError';

export type ExecuteModelingFailure =
  | { ok: false; kind: 'not_ready' }
  | { ok: false; kind: 'busy' }
  | { ok: false; kind: 'execution_failed'; detail: string };

export function toModelingError(failure: ExecuteModelingFailure): ApplicationError {
  if (failure.kind === 'not_ready') {
    return targetNotReadyError();
  }
  if (failure.kind === 'busy') {
    return operationRejectedError();
  }
  return methodExecutionFailedError(failure.detail);
}

export function targetNotReadyError(): ApplicationError {
  return {
    kind: 'application',
    code: APP_ERROR_CODE.TARGET_NOT_READY,
    message: 'Target not ready',
    data: {
      reason: 'bridge_not_ready',
      detail: 'The modeling handler is not registered in the current browser page.',
      recovery: 'open_target_and_retry',
      guidance:
        'Open the target ViewModel page in the browser, wait until it finishes loading, and then run the request again.',
    },
  };
}

export function operationRejectedError(): ApplicationError {
  return {
    kind: 'application',
    code: APP_ERROR_CODE.OPERATION_REJECTED,
    message: 'Operation rejected',
    data: {
      reason: 'bridge_chat_busy',
      detail: 'The AI chat is currently processing another request.',
      recovery: 'retry_later',
      guidance: 'Wait for the current AI chat operation to complete and then retry.',
    },
  };
}

export function methodExecutionFailedError(detail: string): ApplicationError {
  return {
    kind: 'application',
    code: APP_ERROR_CODE.METHOD_EXECUTION_FAILED,
    message: 'Method execution failed',
    data: {
      reason: 'method_execution_failed',
      detail: truncate(detail),
      recovery: 'unknown',
      guidance: 'Check the error detail and retry if appropriate',
    },
  };
}

export function unexpectedError(detail: string): ApplicationError {
  return {
    kind: 'application',
    code: APP_ERROR_CODE.UNEXPECTED_ERROR,
    message: 'Unexpected error',
    data: {
      reason: 'bridge_unhandled_exception',
      detail: truncate(detail),
      recovery: 'unknown',
      guidance: 'An unexpected error occurred in the bridge. Check the error detail and retry if appropriate.',
    },
  };
}
